angular.module('impactx.userctu').controller('UserCTUListController', [UserCTUListController]);

function UserCTUListController() {
    this.meta = {
        rowTemplate: 'modules/userctu/templates/userctulist.row.tmpl.html',
        isSelectAble: false,
        ctrl: this,
        endpoint: '/userctu/list',
        id: 'userctus',
        excelExport: true
    };

    this.getMeta = function() {
        return this.meta;
    };
}